<div id="Permission_id">
<div class="row no-m">
  <div class="col-md-3 shadow bg-gray no-p">
    <div class="lb-head-single vertical-center">
      <h5>Permissions</h5>
    </div>

    <div class="card-scroll media-list" style="height: calc(100vh - 90px);">
      <ul class="nav nav-pills" role="tablist">
   
        <li class="media">
          <span><i class="fa fas fa-users"></i> User Management</span>
          <a href="#" data-bs-toggle="pill" class="view-arrow pull-right no-p active">
            <i class="far fa-arrow-alt-circle-right" tooltip="View" tooltip-placement="left"></i>
          </a>
        </li>
      

      </ul>
    </div>

  </div>


  <div class="col-md-3 no-p bg-gray card">
    <div class="lb-head" style=" height: 130px;">
      <div class="clearfix pb-2 pt-10">
        <h5 class="d-inline">User Management</h5>
        <i class="fas fa-times pull-right" tooltip="Close" tooltip-placement="left"></i>
      </div>
      <div class="form-group d-flex mb-1">
        <select class="form-control addVacationMan_select" required="">
          <option value="" selected="">All Users</option>
        </select>
        <select class="form-control ml-1" required="">
          <option value="" selected="">All</option>

        </select>
      </div>
      <input type="text" class="form-control" placeholder="Search">
    </div>
    <div class="card-scroll" style="height: calc(100vh - 172px);">
      <div class="media d-block">
        <div class="row grid-view list-view">
          <div class="col-md-3 text-center animated slideInLeft">
            <div class="img-car">
              <img src="../../../assets/images/DefaultAvatar.png">
            </div>
          </div>
          <ul class="col-md-7 info-list animated slideInLeft">
            <li class="text-bold ">
              <i class="far fa-user-tie mr-05"></i> Shanka Dev
            </li>
            <li class=""><i class="far fa-phone-alt mr-05"></i>+91-7857653267658</li>
            <li class="text-ellipse "><i class="far fa-building mr-05"></i> Fleet-Uk Transport</li>
          </ul>
          <div class="col-md-2 view-arrow animated slideInLeft">
            <i class="far fa-arrow-alt-circle-right" tooltip="View" tooltip-placement="left"></i>
          </div>
        </div>
      </div>


    </div>
    <div class="livefoot">
      <a class="btn btn-success pull-right">Add</a>
    </div>
  </div>


  <div class="col-md-6 no-p">
    <div class="EditVacaction IP Control View">
      <form class="editUserForm" novalidate="">
        <div class="lb-head-single">
          <h5 class="mt-05">Add User</h5>
      

          <span class="dropdown">
            <a class="pull-right dropdown-toggle" data-toggle="dropdown">
              <i class="fas fa-1px fa-cog color_fleetly"></i>
            </a>
            <span class="dropdown-menu">
              <a class="dropdown-item" href="#"> <i class="fas fa-edit admin_edit mr-05"></i> Edit</a>
              <a class="dropdown-item" href="#"><i class="fas fa-trash-alt admin_trash mr-05"></i> Delete</a>
              <a class="dropdown-item" href="#"> <i class="fas fa-user-alt-slash mr-05"></i> Lock User</a>
              <a class="dropdown-item" href="#"> <i class="fas fa-user-alt-slash mr-05"></i> Disable User</a>
              <a class="dropdown-item" href="#"> <i class="fas fa-user-alt-slash mr-05"></i> User Restriction</a>
              <a class="dropdown-item" href="#"> <i class="fas fa-user mr-05"></i>Login History</a>
              <a class="dropdown-item" href="#"> <i class="fas fa-key mr-05"></i>Reset Password</a>
            </span>
          </span>




          <ul class="dropdown-menu actions_ddl" style="">
            <li class="user-header">
              <a class="view-arrow">
                <span tooltip="View" tooltip-placement="bottom" class="cursor-pointer d-block">
                  Edit <i class="fas fa-pen cursor-pointer font_14"></i>
                </span>
              </a>
            </li>
            <li class="user-header">
              <a class="view-arrow" data-toggle="modal" data-bs-toggle="modal" data-bs-target="#delete_modal">
                <span tooltip="View" tooltip-placement="bottom" class="cursor-pointer d-block">
                  Delete <i class="fas fa-trash-alt cursor-pointer font_14"></i>
                </span>
              </a>
            </li>
          </ul>
        </div>

        <div class="modal-body card-scroll bg-white">
          <div class="row mt-1">
            <div class="col-md-6 pr-0">
              <div class="mb-1">
                <label class="d-block">Fleet</label>
                <select required="" class="form-control">
                  <option value="">Select </option>
                </select>
              </div>
              <div class="mb-1">
                <label class="d-block"> Select User</label>
                <select required="" class="form-control">
                  <option value="">Select User</option>
                </select>
              </div>
              <div class="mb-1">
                <label for="IPName">First Name</label>
                <input type="text" id="roleName" class="form-control" required="">
              </div>


            </div>
            <div class="col-md-6 pl0">
              <div class="profile-img-container">
                <img class="img-thumbnail img-circle img-responsive" src="../../../assets/images/DefaultAvatar.png">
                <input type="file" accept=".png,.jpg,.jpeg">
              </div>
            
              <div class="mb-1">
                <label for="IPName">Last Name</label>
                <input type="text" id="roleName" class="form-control" required="">
              </div>
             

            </div>
          </div>
          
          <div class="row">
            <div class="form-group col-md-3">

              <label class="d-block">Read Only</label>
              <label class="switch switch-small">
                <input type="checkbox">
                <span class="slider"></span>
              </label>




            </div>
            <div class="form-group col-md-3">

              <label class="d-block">Update</label>
              <label class="switch switch-small">
                <input type="checkbox">
                <span class="slider"></span>
              </label>




            </div>
            <div class="form-group col-md-3">

              <label class="d-block">Download</label>
              <label class="switch switch-small">
                <input type="checkbox">
                <span class="slider"></span>
              </label>




            </div>
            <div class="form-group col-md-3">

              <label class="d-block">Uplaod</label>
              <label class="switch switch-small">
                <input type="checkbox">
                <span class="slider"></span>
              </label>




            </div>
          </div>
        
        </div>


        <div class="livefoot d-block">
          <a class="btn btn-charcol pull-left mt-05">Cancel</a>
          <a class="btn btn-success pull-right mt-05">Save</a>
        </div>
      </form>

    </div>



  </div>
</div>
</div>
<div id="delete_modal" class="modal right  in deleteModal" style="z-index: 40 !important;" aria-modal="true" role="dialog">
  <div class="modal-dialog" style="width: 45%;">
    <div class="modal-content">
      <div class="modal-header lb-head-single">
        <h5>Delete</h5>
        <i tooltip-placement="left" tooltip="Close" data-bs-dismiss="modal" class="fas fa-times pull-right"></i>
      </div>
      <div class="modal-body">
        <h3>
          <i class="fal fa-trash-alt"></i>
        </h3>
        <h4 class="modal-title">Delete Record</h4>
        <p>Are you sure you want to delete <span>Text</span> ?</p>
        <p><small>This action cannot be undone.</small></p>
      </div>
      <div class="modal-footer">
        <button data-bs-dismiss="modal" class="btn btn-charcol mr-1">Cancel</button>
        <a class="btn btn-success">Delete</a>
      </div>
    </div>
  </div>
</div>
